export default __webpack_public_path__ + "static/media/help_center.ff148d81.md";